/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestRegisterTrackingDetailRequest
 */
export interface RequestRegisterTrackingDetailRequest {
    /**
     * 
     * @type {number}
     * @memberof RequestRegisterTrackingDetailRequest
     */
    groupNum: number;
    /**
     * 
     * @type {boolean}
     * @memberof RequestRegisterTrackingDetailRequest
     */
    isApiPlan: boolean;
    /**
     * 
     * @type {number}
     * @memberof RequestRegisterTrackingDetailRequest
     */
    planId: number;
    /**
     * 
     * @type {string}
     * @memberof RequestRegisterTrackingDetailRequest
     */
    shipmentConfirmationId?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestRegisterTrackingDetailRequest
     */
    tenantId: number;
    /**
     * 
     * @type {string}
     * @memberof RequestRegisterTrackingDetailRequest
     */
    trackingId: string;
    /**
     * 
     * @type {number}
     * @memberof RequestRegisterTrackingDetailRequest
     */
    userId: number;
}

/**
 * Check if a given object implements the RequestRegisterTrackingDetailRequest interface.
 */
export function instanceOfRequestRegisterTrackingDetailRequest(value: object): value is RequestRegisterTrackingDetailRequest {
    if (!('groupNum' in value) || value['groupNum'] === undefined) return false;
    if (!('isApiPlan' in value) || value['isApiPlan'] === undefined) return false;
    if (!('planId' in value) || value['planId'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('trackingId' in value) || value['trackingId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function RequestRegisterTrackingDetailRequestFromJSON(json: any): RequestRegisterTrackingDetailRequest {
    return RequestRegisterTrackingDetailRequestFromJSONTyped(json, false);
}

export function RequestRegisterTrackingDetailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestRegisterTrackingDetailRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'groupNum': json['group_num'],
        'isApiPlan': json['is_api_plan'],
        'planId': json['plan_id'],
        'shipmentConfirmationId': json['shipment_confirmation_id'] == null ? undefined : json['shipment_confirmation_id'],
        'tenantId': json['tenant_id'],
        'trackingId': json['tracking_id'],
        'userId': json['user_id'],
    };
}

export function RequestRegisterTrackingDetailRequestToJSON(json: any): RequestRegisterTrackingDetailRequest {
    return RequestRegisterTrackingDetailRequestToJSONTyped(json, false);
}

export function RequestRegisterTrackingDetailRequestToJSONTyped(value?: RequestRegisterTrackingDetailRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'group_num': value['groupNum'],
        'is_api_plan': value['isApiPlan'],
        'plan_id': value['planId'],
        'shipment_confirmation_id': value['shipmentConfirmationId'],
        'tenant_id': value['tenantId'],
        'tracking_id': value['trackingId'],
        'user_id': value['userId'],
    };
}

